import { SET_FORM_INFOS } from 'root/src/client/logic/form/actionIds'

export default (moduleKey, infos) => ({
	type: SET_FORM_INFOS,
	payload: { moduleKey, infos },
})
